import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import './MobileNav.css';

/// モバイル用固定フッターナビゲーション
const MobileNav: React.FC = () => {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  /// アクティブリンクの判定
  const isActiveLink = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="mobile-nav">
      <div className="mobile-nav-container">
        <Link 
          to="/" 
          className={`mobile-nav-item ${isActiveLink('/') ? 'active' : ''}`}
        >
          <div className="mobile-nav-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
            </svg>
          </div>
          <span className="mobile-nav-label">ホーム</span>
        </Link>
        
        <Link 
          to="/search" 
          className={`mobile-nav-item ${isActiveLink('/search') ? 'active' : ''}`}
        >
          <div className="mobile-nav-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </div>
          <span className="mobile-nav-label">検索</span>
        </Link>
        
        <Link 
          to="/watch-together" 
          className={`mobile-nav-item ${isActiveLink('/watch-together') ? 'active' : ''}`}
        >
          <div className="mobile-nav-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 4v4h4V6.47L22 8V4h-6zM2 12C2 6.48 6.48 2 12 2h2v2h-2C7.58 4 4 7.58 4 12s3.58 8 8 8 8-3.58 8-8v-2h2v2c0 5.52-4.48 10-10 10S2 17.52 2 12zm7-1v4l3-2-3-2z"/>
            </svg>
          </div>
          <span className="mobile-nav-label">視聴</span>
        </Link>
        
        <Link 
          to="/links" 
          className={`mobile-nav-item ${isActiveLink('/links') ? 'active' : ''}`}
        >
          <div className="mobile-nav-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H6.9C4.01 7 1.6 9.42 1.6 12s2.41 5 5.3 5h4v-1.9H6.9c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9.1-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.89 0 5.3-2.42 5.3-5s-2.41-5-5.3-5z"/>
            </svg>
          </div>
          <span className="mobile-nav-label">リンク集</span>
        </Link>

        <button
          type="button"
          className="mobile-nav-item mobile-nav-item--theme"
          onClick={toggleTheme}
          aria-label={theme === 'light' ? 'ダークモードに切り替え' : 'ライトモードに切り替え'}
          title={theme === 'light' ? 'ダークモードに切り替え' : 'ライトモードに切り替え'}
        >
          <div className="mobile-nav-icon">
            <span className="mobile-nav-theme-icon">
              {theme === 'light' ? '🌙' : '☀️'}
            </span>
          </div>
          <span className="mobile-nav-label">
            {theme === 'light' ? 'ダーク' : 'ライト'}
          </span>
        </button>
      </div>
    </nav>
  );
};

export default MobileNav; 